import React, { useState } from "react";
import { SketchPicker,HuePicker } from "react-color";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./ColorPalette.css";
const  ColorPicker =({colorPickerOptionArray,activeColorPickerValue,setActiveColorPickerValue}) =>{
  const [color, setColor] = useState(activeColorPickerValue);
  const dispatch = useDispatch();
     
      const [activeColor,setActiveColor] = useState(activeColorPickerValue)
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     
  const handleChange = (newColor) => {
    setColor(newColor.hex);
  };
  function rgbaToHex(rgba) {
    // Extract RGBA values using regex
    const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d\.]+)?\)/);
  
    if (!match) {
      throw new Error("Invalid RGBA color format");
    }
  
    let r = parseInt(match[1]);
    let g = parseInt(match[2]);
    let b = parseInt(match[3]);
    let a = match[4] !== undefined ? parseFloat(match[4]) : 1;
  
    // Validate and clamp values
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));
    a = Math.min(1, Math.max(0, a));
  
    // Convert RGB to HEX
    const hex = ((r << 16) | (g << 8) | b).toString(16).padStart(6, "0");
  
    // Convert Alpha to HEX (if less than 1)
    const alphaHex = a < 1 ? Math.round(a * 255).toString(16).padStart(2, "0") : "";
  
    return `#${hex}${alphaHex}`.toUpperCase();
  }
  

  return (
    <div style={{ padding: "0px",width:"210px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",background:"#fff" }}>
      
      <SketchPicker color={color}
        onChange={handleChange}
        width="220px"
        disableAlpha // Hides the alpha slider
        presetColors={[]} // Remove preset colors
        
        styles={{
          default: {
            picker: {
              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.01)",
              borderRadius: "0px",
              padding: "0px",
            },
          },
        }} />
      
      <div className="gridForColorTextBox"> 
        <input className="input-textbox-color" style={{border:"1px solid rgba(144, 202, 249,0.4)"}} type="text" value={color?.toLocaleUpperCase()} 
         onChange={(e)=>setColor(e.target.value)}/>
         <div
        style={{
          
          backgroundColor: color,border:"1px solid  rgba(144, 202, 249,0.4)"
        }} className="colorBoxLeft"
      > </div>
      </div>
     
     
<div className="gridForColorBoxSquare">
{colorPickerOptionArray.map((color, index) => (
        <div 
        onMouseEnter={()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave} 
        onClick={()=>setColor(rgbaToHex(color))}
          key={index} className="colorBoxSquare" style={{background:color}}></div>))
          }
</div>
<button className="colorPickerButtonFill" onClick={()=>{setActiveColorPickerValue(color);
  setActiveColor(color)}}>Save</button>
<button className="colorPickerButtonBlank" onClick={()=>{setColor(activeColor)}}>Reset </button>

    </div>
  );
}

export default ColorPicker;
